import Feature from "../Feature";
import { Region, User } from "../store";

export const getRegion = (user: User) =>
  user?.features.includes(Feature.usAccess) ? Region.US : Region.UK;

export default getRegion;
